
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[clientName]/register",
      function () {
        return require("private-next-pages/[clientName]/register/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[clientName]/register"])
      });
    }
  